// Historical addresses explicitly retired to the home page by the site owner.
// Keep this list exact so other missing or newly created cards keep their routes.
const retiredPlantPaths = new Set([
  '/catalog/product-12825',
  '/catalog/product-23587',
  '/catalog/product-25206',
  '/catalog/product-25468',
  '/catalog/product-26311',
  '/catalog/product-27608',
  '/catalog/product-27611',
  '/catalog/product-27612',
  '/catalog/product-27620',
  '/catalog/product-6532',
  '/catalog/product-7965',
  '/catalog/product-17879',
  '/catalog/product-24797',
  '/catalog/product-24862',
  '/catalog/product-24905',
  '/catalog/product-25159',
  '/catalog/product-25220',
]);

export default defineNuxtRouteMiddleware(to => {
  const path = to.path.replace(/\/+$/, '');
  if (path === '/catalog/product-14666') {
    return navigateTo('/catalog/product-5843', { redirectCode: 301, replace: true });
  }
  if (retiredPlantPaths.has(path)) {
    return navigateTo('/', { redirectCode: 301, replace: true });
  }
});
